import { useEffect } from 'react';
import TeacherShell, { TeacherPageHeader } from '../../../components/layout/TeacherShell';
import VisitHistoryList from '../../../components/sentence_studio/VisitHistoryList';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';

export default function SentenceStudioIndex({ visits = [] }) {
  const { clear } = useBreadcrumbs();
  useEffect(() => {
    // The index is a dead-end relative to the nav axis; clear any stale trail.
    clear();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TeacherShell scrollTitle="Sentence Studio">
      <TeacherPageHeader
        title="Sentence Studio"
        subtitle="Sentences you have analyzed with Claude"
      />
      <VisitHistoryList visits={visits} basePath="/teacher/sentence_studio" />
    </TeacherShell>
  );
}
